import { trigger, state, style, transition, animate } from '@angular/animations';

export const accordionAnimation = [
  trigger('accordionAnimation', [
    state('void', style({ height: 0, overflow: 'hidden' })),
    state('visible', style({ height: '*', overflow: 'hidden' })),
    transition('void <=> visible', animate('0.5s')),
  ]),
];
